import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material/styles';

export const classes: {
    defaultProps?: ComponentsProps['MuiOutlinedInput'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiOutlinedInput'];
    variants?: ComponentsVariants['MuiOutlinedInput'];
} = {
    styleOverrides: {
        root: {
            borderRadius: '4px',
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: '#2196F3',
                },
            },
        },
        input: {
            padding: '17px 14px',
            height: 22,
        },
        multiline: {
            padding: '17px 14px',
        },
        inputMultiline: {
            width: '100%',
            '&::-webkit-scrollbar': {
                width: 5,
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#2C93F0',
                borderRadius: 2.5,
            },
            '&::-webkit-scrollbar-track': {
                background: '#D5DFEB',
                borderRadius: 2.5,
            },
        },
    },
};
